                                                                                                                                                                                         // Main App component - Converted from app.vue and layout/default.vue
// Handles routing and provides the main layout structure
import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import SearchPopup from './components/SearchPopup';

// Import pages (will be converted incrementally)
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ServicePage from './pages/ServicePage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectsDetailPage from './pages/ProjectsDetailPage';

const App: React.FC = () => {
  const location = useLocation();

  // Always set tab title to Agro Elite
  useEffect(() => {
    document.title = 'Agro Elite';
  }, [location.pathname]);

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* <Route path="/index2" element={<HomePage2 />} />
        <Route path="/index3" element={<HomePage3 />} />
        <Route path="/index4" element={<HomePage4 />} />
        <Route path="/index5" element={<HomePage5 />} /> */}
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/service" element={<ServicePage />} />
        <Route path="/service-detail" element={<ServiceDetailPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects_detail" element={<ProjectsDetailPage />} />
        {/* <Route path="/product" element={<ProductPage />} />
        <Route path="/product-detail" element={<ProductDetailPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news_detail" element={<NewsDetailPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/farmers" element={<FarmersPage />} />
        <Route path="/why_choose_us" element={<WhyChooseUsPage />} /> */}
      </Routes>
      <SearchPopup />
    </Layout>
  );
};

export default App;
